export function mapKeys(obj, func) {
    return Object.keys(obj).reduce(function (result, key) {
        var val = obj[key];
        result[func(key, val)] = val;
        return result;
    }, {});
}
export default mapKeys;

//# sourceMappingURL=mapKeys.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/utils/mapKeys.js
// module id = 75
// module chunks = 0